import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { matchSorter } from "match-sorter";
import { compose, filter, is, prop, sortBy, toLower } from "ramda";
import { useOrganizationsByRole } from "../../../manage-organizations/organizationServices";
import { notBlank } from "../../../util/ext";
import { locality } from "../../../util/organizationUtil";
import VirtualizedListbox, {
  LISTBOX_BORDER_STYLE,
} from "../../../components/VirtualizedListbox";

const filterOptions = (options, { inputValue }) =>
  matchSorter(options, inputValue, {
    keys: [
      "organizationName",
      "location.locality",
      "location.administrativeArea",
    ],
  });

// Suggests public libraries, but any library name can be typed
const LocalLibraryField = ({ value, onChange }) => {
  const libraries = useOrganizationsByRole("ROLE_PUBLIC_LIBRARY");
  const options = sortBy(
    compose(toLower, prop("organizationName")),
    filter(prop("active"), libraries.data ?? []),
  );

  return (
    <Autocomplete
      id="local-library"
      freeSolo
      disableListWrap
      loading={libraries.isLoading}
      options={options}
      filterOptions={filterOptions}
      value={notBlank(value) ? value : null}
      isOptionEqualToValue={(option, current) =>
        option.organizationName === current
      }
      inputValue={value}
      onInputChange={(_event, text, reason) => {
        if (reason === "input" || reason === "clear") {
          onChange(text);
        }
      }}
      onChange={(_event, selection) => {
        if (selection && !is(String, selection)) {
          onChange(selection.organizationName);
        }
      }}
      getOptionLabel={option =>
        is(String, option) ? option : option.organizationName
      }
      ListboxComponent={VirtualizedListbox}
      ListboxProps={{ itemSize: 60, listStyle: LISTBOX_BORDER_STYLE }}
      renderOption={({ key, ...props }, option) => (
        <li key={key} {...props}>
          <Box width="100%">
            <Typography noWrap style={{ fontWeight: "bold" }}>
              {option.organizationName}
            </Typography>
            {option.location && (
              <Typography noWrap>{locality(option)}</Typography>
            )}
          </Box>
        </li>
      )}
      renderInput={params => (
        <TextField
          {...params}
          label="Local Library"
          variant="standard"
          fullWidth
        />
      )}
    />
  );
};

export default LocalLibraryField;
